__turbopack_context__.v({
  "body": "TeamProjectsEditProject-module-scss-module__guSDDa__body",
  "divider": "TeamProjectsEditProject-module-scss-module__guSDDa__divider",
  "fieldGroup": "TeamProjectsEditProject-module-scss-module__guSDDa__fieldGroup",
  "info": "TeamProjectsEditProject-module-scss-module__guSDDa__info",
  "infoLink": "TeamProjectsEditProject-module-scss-module__guSDDa__infoLink",
  "infoText": "TeamProjectsEditProject-module-scss-module__guSDDa__infoText",
  "label": "TeamProjectsEditProject-module-scss-module__guSDDa__label",
  "projectLogo": "TeamProjectsEditProject-module-scss-module__guSDDa__projectLogo",
  "projectName": "TeamProjectsEditProject-module-scss-module__guSDDa__projectName",
  "readOnlyInput": "TeamProjectsEditProject-module-scss-module__guSDDa__readOnlyInput",
  "removeBtn": "TeamProjectsEditProject-module-scss-module__guSDDa__removeBtn",
  "required": "TeamProjectsEditProject-module-scss-module__guSDDa__required",
});
